<div class="py-2">
  <div class="d-flex" [ngClass]="{ 'flex-row align-items-start': textInputInRow, 'flex-column align-items-stretch': !textInputInRow }">
    <div class="d-flex align-items-start" [ngClass]="{ 'col-6': textInputInRow }">
      <span class="text-nowrap me-2 generator-title">
        {{ label | localize }}
      </span>
      <app-field-info
        class="me-2"
        [testId]="testId + '-description-icon'"
        [infoText]="description"
      ></app-field-info>

      <span class="d-flex align-items-start" [ngClass]="{ 'ms-auto me-2': textInputInRow } ">
        <span
          *ngIf="values.length > 0"
          class="d-flex flex-column align-items-end"
        >
            <span
              *ngFor="let value of values; let index = index"
              [attr.data-testId]="testId + '-badge-' + index.toString()"
              class="badge rounded-pill generator-badge bg-purple mb-1"
              title="{{ 'generator_label_findings_selection_badge_tooltip' | localize }}"
            >{{ value }}</span>
        </span>

        <label
          data-testId="generation-option"
          *ngFor="let option of options"
          class="ms-2 d-inline-flex text-nowrap"
          [ngClass]="{ 'mt-1': textInputInRow }"
        >
          <input
            type="radio"
            class="me-1"
            name="{{ name }}"
            (click)="radioButtonClicked(option)"
            [value]="option"
            [ngModel]="selectedOption"
            (ngModelChange)="selectOption(option)"
          />
          {{ option.optionLabel | localize }}
        </label>
      </span>
    </div>
    <app-generator-text-field
      [ngClass]="{ 'col-6': textInputInRow, 'col-12': !textInputInRow}"
      [testId]="testId"
      [text]="generatedText"
      (onTextChange)="onGeneratedTextEdited($event)"
    >
    </app-generator-text-field>
  </div>
</div>
